<template>
  <div>
    <div class="mt-5">
      <custom-separator
        class="my-4"
        text="Listado de Equipos Requisados Para Servicios de Asistencia Tecnológica"
      />
      <equipment-row
        v-for="(item, index) in referral.equipments"
        :key="index"
        :equipment="item"
        @open="handlerOpen"
        @close="handlerClose"
        @refresh="() => search(1)"
      />
      <div class="mt-4">
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';
import EquipmentRow from '../../EquipmentRow.vue';

import referralAndEquipmentsService from '@/services/api/referralsandequipments.api';
export default {
  name: 'ReferralEquipments',
  components: {
    CustomSeparator,
    Pagination,
    EquipmentRow,
  },
  props: {
    referral: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pagination: {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: 10,
      },
    };
  },
  computed: {
    referralId() {
      return Number(this.$route.params.id);
    },
  },
  async mounted() {
    if (!this.referral.equipments?.length)
      await this.search(this.pagination.currentPage);
  },
  methods: {
    async search(page) {
      try {
        const payload = {
          peiAtServiceId: this.referralId,
          currentPage: page,
          pageSize: 10,
        };
        const { data } = await referralAndEquipmentsService.searchEquipments(
          payload
        );

        this.referral.equipments = data.data.map((x) => ({
          ...x,
          isOpen: false,
        }));
        this.pagination = {
          ...this.pagination,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        };
        this.$emit('loaded');
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error en la búsqueda de Equipos Requisados',
          'error'
        );
      }
    },
    handlerOpen(item) {
      this.referral.equipments
        .filter((x) => x.id !== item.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));
      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
    async onPageChange(page) {
      this.search(page);
    },
  },
};
</script>

<style></style>
